/**
 * Global configuration object
 */
export const config = {
  api: {
    BASE_URL: "https://template-manager-api.test.asigner.cl/api",
  },
};
